import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TileDescription } from "../store/types";
import { defaultRootState } from "./default-root-state";
import entries from "lodash/entries";
import { AppAnalytics } from "common/Database";

interface SetTileDescriptionForOwnerPayload {
    readonly ownerID: string;
    readonly tiles: readonly [string, TileDescription][];
}

interface SetTileAnalyticsForOwnerPayload {
    readonly ownerID: string;
    readonly appID: string;
    readonly analytics: AppAnalytics;
}

const tileSlice = createSlice({
    name: "tiles",
    initialState: defaultRootState.tiles,
    reducers: {
        setTileDescriptionsForOwner: (
            state,
            { payload: { ownerID, tiles } }: PayloadAction<SetTileDescriptionForOwnerPayload>
        ) => {
            for (const [id, t] of entries(state)) {
                if (t === "loading") continue;
                if (t.userID === ownerID) {
                    delete state[id];
                }
            }
            for (const [id, t] of tiles) {
                // This weird object copy is just required to pacify immer.
                state[id] = { ...t, authIDs: [...(t.authIDs ?? [])] };
            }
        },
        setTileAnalytics: (state, action: PayloadAction<SetTileAnalyticsForOwnerPayload>) => {
            const { appID, analytics } = action.payload;
            const cur = state[appID];
            if (cur !== "loading" && cur !== undefined) {
                state[appID] = {
                    ...cur,
                    analytics,
                };
            }
        },
        setTileLoadingAction: (state, action: PayloadAction<string>) => {
            state[action.payload] = "loading";
        },
    },
});

export const { setTileDescriptionsForOwner, setTileLoadingAction, setTileAnalytics } = tileSlice.actions;
export default tileSlice.reducer;
